<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>发票管理</li>
                <li><a href="invoiceinformationmanage">发票信息管理</a></li>
            </ul>
        </div>
        <div id="usual1" class="usual"> 
            <div class="formbody">
                <div class="formtitle"><span>发票信息管理</span></div>
                <ul class="forminfo">
                    <li>
                        <label>发票抬头<b>*</b></label>
                        <div class="vocation" style="margin-left:10px;">
                            <input v-model="lookedup" type="text" class="dfinput" placeholder="请填写营业执照上的全称"/>
                        </div>
                    </li>
                    <li>
                        <label>纳税人识别号<b>*</b></label>
                        <div class="vocation" style="margin-left:10px;">
                            <input v-model="taxpayerId" type="text" class="dfinput" placeholder="请填写15到20位有效纳税人识别号"/>
                        </div>
                    </li>
                    <li>
                        <label>银行账号<b>*</b></label>
                        <div class="vocation" style="margin-left:10px;">
                            <input v-model="cardId" type="text" class="dfinput" placeholder="请填写您开户许可证上的银行账号"/>
                        </div>
                    </li>
                    <li>
                        <label>开户行<b>*</b></label>
                        <div class="vocation" style="margin-left:10px;">
                            <input v-model="bank" type="text" class="dfinput" placeholder="请填写您开户许可证上的开户银行"/>
                        </div>
                    </li>
                    <li>
                        <label>注册地址<b>*</b></label>
                        <div class="vocation" style="margin-left:10px;">
                            <input v-model="corpAddr" type="text" class="dfinput" placeholder="请填写营业执照上的注册地址"/>
                        </div>
                    </li>
                    <li>
                        <label>注册企业电话<b>*</b></label>
                        <div class="vocation" style="margin-left:10px;">
                            <input v-model="corpTel" type="text" class="dfinput" placeholder="请填写您公司有效的联系电话"/>
                        </div>
                    </li>
                    <li>
                        <input class="sure" type="button" value="保存并提交" @click="update()" style="margin-left: 95px;">
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import cookie from '@/components/cookie.vue'

export default {
    data() {
        return {
            lookedup: '',
            taxpayerId: '',
            cardId: '',
            bank: '',
            corpAddr: '',
            corpTel: '',
            // invoicetype: '电子发票',
            invoiceinformation: {},
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted(){
        this.getinvoiceinformation();
    },
    methods: {
        getinvoiceinformation() {
            var that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/invoice/getinvoiceinformation.json",
                data:data,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    if(res.data.invoiceinformation == undefined)
                    {

                    }
                    else
                    {
                        that.invoiceinformation = res.data.invoiceinformation;
                        that.lookedup = that.invoiceinformation.lookedup;
                        that.taxpayerId = that.invoiceinformation.taxpayerId;
                        that.cardId = that.invoiceinformation.cardId;
                        that.bank = that.invoiceinformation.bank;
                        that.corpAddr = that.invoiceinformation.corpAddr;
                        that.corpTel = that.invoiceinformation.corpTel;
                    }
                }
                else
                {
                    that.$alert(res.data.msg);
                }
            })
        },
        update() {
            if(this.lookedup.trim().length == 0)
            {
                this.$alert("发票抬头不能为空");
                return false;
            }
            if(this.taxpayerId.trim().length == 0)
            {
                this.$alert("纳税人识别号不能为空");
                return false;
            }
            if(this.cardId.trim().length == 0)
            {
                this.$alert("银行账号不能为空");
                return false;
            }
            if(this.bank.trim().length == 0)
            {
                this.$alert("开户行不能为空");
                return false;
            }
            if(this.corpAddr.trim().length == 0)
            {
                this.$alert("注册地址不能为空");
                return false;
            }
            if(this.corpTel.trim().length == 0)
            {
                this.$alert("注册企业电话不能为空");
                return false;
            }
            var that = this
            let param = {'lookedup': this.lookedup, 'taxpayerId': this.taxpayerId, 'cardId': this.cardId, 'bank': this.bank, 
                'corpAddr': this.corpAddr, 'corpTel': this.corpTel}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/invoice/updateinvoiceinformation.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$alert("提交成功");
                    that.getinvoiceinformation();
                }
                else
                {
                    that.$alert(res.data.msg);
                }
            })
        },
        checkinvoicetype(invoicetype) {
            if(invoicetype == 0)
            {
                this.invoicetype = "电子发票"
            }
            else if(invoicetype == 1)
            {
                this.invoicetype = "普通发票"
            }
            else if(invoicetype == 2)
            {
                this.invoicetype = "增值税专用发票"
            }
        }
    }
}

</script>

<style>

.el-radio__input{top:-10px;}

</style>


// WEBPACK FOOTER //
// src/components/invoice/invoiceinformationmanage.vue